import { Component, ChangeDetectionStrategy, input, signal, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-tab-grup',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="tab-grup">
      <div class="tab-basliklar">
        @for (s of sekmeler(); track s.id) {
          <button class="tab-btn" [class.aktif]="aktifSekme() === s.id"
                  [style.--aktif-renk]="aktifRenk()"
                  (click)="aktifSekme.set(s.id)">
            @if (s.simge) { <span class="tab-simge">{{ s.simge }}</span> }
            <span>{{ s.baslik }}</span>
          </button>
        }
      </div>
      <div class="tab-icerik" [attr.data-id]="aktifSekme()">
        {{ aktifIcerik() }}
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .tab-grup { min-height: 0; }
    .tab-basliklar {
      display: flex; gap: 2px; overflow-x: auto;
      border-bottom: 1px solid var(--py-sinir, rgba(255,255,255,0.08));
      scrollbar-width: none;
      &::-webkit-scrollbar { display: none; }
    }
    .tab-btn {
      display: flex; align-items: center; gap: 4px;
      padding: 6px 12px; border: none; background: none; cursor: pointer;
      font-size: 0.82em; color: var(--py-metin-ikincil, #999);
      border-bottom: 2px solid transparent;
      white-space: nowrap; transition: all 0.2s;
      &:hover { color: var(--py-metin, #e0e0e0); }
      &.aktif {
        color: var(--aktif-renk, #1890ff);
        border-bottom-color: var(--aktif-renk, #1890ff);
        font-weight: 600;
      }
    }
    .tab-simge { font-size: 1.1em; }
    .tab-icerik {
      padding: 8px 4px; font-size: 0.85em;
      color: var(--py-metin, #e0e0e0);
      animation: tabFade 0.25s ease;
    }
    @keyframes tabFade {
      from { opacity: 0; transform: translateY(4px); }
      to   { opacity: 1; transform: translateY(0); }
    }
  `],
})
export class TabGrupComponent {
  sekmeler = input<{ id: string; baslik: string; simge?: string; icerik?: string }[]>([]);
  aktifRenk = input('#1890ff');
  aktifSekme = signal('');

  aktifIcerik = computed(() => {
    const s = this.sekmeler().find(s => s.id === this.aktifSekme());
    return s?.icerik ?? '';
  });

  constructor() {
    effect(() => {
      const ilk = this.sekmeler()[0];
      if (ilk && !this.aktifSekme()) this.aktifSekme.set(ilk.id);
    });
  }
}
